export default __webpack_public_path__ + "images/shopifyIcon.c488e4c32ee9e5f5baedc79768f29ab8.png";